// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3A9lq","imageUploader":"EGiftCard_imageUploader__2NImj"};